// src/components/FeaturesSection.jsx
import React from 'react';
import { Brain, Clock, Trophy, Award } from 'lucide-react';

const FeaturesSection = () => {
    const featureShowcase = [
        {
            icon: Brain,
            title: "AI-Powered Learning",
            description: "Personalized practice questions and adaptive learning paths tailored just for you",
            points: [
                "Smart question generation based on your performance",
                "Real-time analysis of your strengths and weaknesses",
                "Dynamic difficulty adjustment"
            ]
        },
        {
            icon: Trophy,
            title: "Gamified Experience",
            description: "Turn your study sessions into exciting quests with rewards and achievements",
            points: [
                "Daily challenges and streaks",
                "Achievement badges and rewards",
                "Competitive leaderboards"
            ]
        },
        {
            icon: Clock,
            title: "Bite-sized Learning",
            description: "Master complex topics in just 15 minutes with our micro-learning approach",
            points: [
                "Focused learning modules",
                "Quick revision sessions",
                "Progress tracking"
            ]
        }
    ];

    return (
        <section className="py-32 bg-gray-50">
            <div className="container mx-auto px-4">
                <h2 className="text-4xl font-black text-center mb-24" style={{ color: '#6A5AE0' }}>
                    Unlock Your Learning Potential
                    <div className="h-1 w-24 mx-auto mt-6 rounded-full" style={{ backgroundColor: '#6A5AE0', opacity: 0.3 }} />
                </h2>

                <div className="grid md:grid-cols-3 gap-12">
                    {featureShowcase.map((feature, index) => (
                        <div key={index} className="bg-white p-8 rounded-3xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                            <div className="flex items-center gap-4 mb-6" style={{ color: '#6A5AE0' }}>
                                <feature.icon className="w-8 h-8" />
                                <h3 className="text-2xl font-bold">{feature.title}</h3>
                            </div>
                            <p className="text-gray-600 mb-6">{feature.description}</p>
                            <ul className="space-y-3">
                                {feature.points.map((point, i) => (
                                    <li key={i} className="flex items-start gap-3">
                                        <div className="mt-1">
                                            <Award className="w-5 h-5" style={{ color: '#6A5AE0' }} />
                                        </div>
                                        <span className="text-gray-600">{point}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;